

jQuery(document).ready(function($) {
	display_popup_onload();

	
	var $current = $('.carousel-navigation .paging .current');
	var $total = $('.carousel-navigation .paging .total');
	$('.normal-carousel .image-carousel-boxes').on('init reInit afterChange', function(event, slick, currentSlide, nextSlide){
	    //currentSlide is undefined on init -- set it to 0 in this case (currentSlide is 0 based)
	    // reset for multiple
	    var $current = $('.normal-carousel .carousel-navigation .paging .current');
		var $total = $('.normal-carousel .carousel-navigation .paging .total');
	    var i = (currentSlide ? currentSlide : 0) + 1;
	    $current.text('0'+i);
	    $total.text('0'+slick.slideCount);
	    $('.normal-carousel progress').val(i);
	    $('.normal-carousel progress').attr('max', slick.slideCount);
	});
	$('.wide-carousel .image-carousel-boxes').on('init reInit afterChange', function(event, slick, currentSlide, nextSlide){
	    //currentSlide is undefined on init -- set it to 0 in this case (currentSlide is 0 based)
	    var $current = $('.wide-carousel .carousel-navigation .paging .current');
		var $total = $('.wide-carousel .carousel-navigation .paging .total');
	    var i = (currentSlide ? currentSlide : 0) + 1;
	    $current.text('0'+i);
	    $total.text('0'+slick.slideCount);
	    $('.wide-carousel progress').val(i);
	    $('.wide-carousel progress').attr('max', slick.slideCount);
	});
	$('.image-only-carousel-boxes').on('init reInit afterChange', function(event, slick, currentSlide, nextSlide){
	    //currentSlide is undefined on init -- set it to 0 in this case (currentSlide is 0 based)
	    var i = (currentSlide ? currentSlide : 0) + 1;
	    $current.text('0'+i);
	    $total.text('0'+slick.slideCount);
	    $('.image-only-carousel-wrapper progress').val(i);
	    $('.image-only-carousel-wrapper progress').attr('max', slick.slideCount);
	});
	$('.menu-carousel-boxes').on('init reInit afterChange', function(event, slick, currentSlide, nextSlide){
	    //currentSlide is undefined on init -- set it to 0 in this case (currentSlide is 0 based)
	    var i = (currentSlide ? currentSlide : 0) + 1;
	    $current.text('0'+i);
	    $total.text('0'+slick.slideCount);
	    
	    $('.menu-carousel-wrapper progress').val(i);
	    $('.menu-carousel-wrapper progress').attr('max', slick.slideCount);
	});
	
	$('.tripadvisor-carousel-boxes').on('init reInit afterChange', function(event, slick, currentSlide, nextSlide){
	    //currentSlide is undefined on init -- set it to 0 in this case (currentSlide is 0 based)
	    var $current = $('.tripadvisor-carousel-wrapper .carousel-navigation .paging .current');
		var $total = $('.tripadvisor-carousel-wrapper .carousel-navigation .paging .total');
	    var i = (currentSlide ? currentSlide : 0) + 1;
	    $current.text('0'+i);
	    $total.text('0'+slick.slideCount);
	    $('.tripadvisor-carousel-wrapper progress').val(i);
	    $('.tripadvisor-carousel-wrapper progress').attr('max', slick.slideCount);
	});
	
	$('.normal-carousel .text-carousel-boxes').slick({
	  slidesToShow: 1,
	  slidesToScroll: 1,
	  arrows: false,
	  fade: true,
	  asNavFor: '.normal-carousel .image-carousel-boxes'
	});
	$('.normal-carousel .image-carousel-boxes').slick({
	  slidesToShow: 2,
	  slidesToScroll: 1,
	  asNavFor: '.normal-carousel .text-carousel-boxes',
	  dots: false,
	  centerMode: false,
	  focusOnSelect: true,
	  nextArrow:  $('.normal-carousel .carousel-navigation .arrows .next'),
	  prevArrow:  $('.normal-carousel .carousel-navigation .arrows .prev'),
	  responsive: [
	    {
	      breakpoint: 1024,
	      settings: {
	        slidesToShow: 1,
	      }
	    },
	  ]
	});
	
	$('.wide-carousel .text-carousel-boxes').slick({
	  slidesToShow: 1,
	  slidesToScroll: 1,
	  arrows: false,
	  fade: true,
	  asNavFor: '.wide-carousel .image-carousel-boxes'
	});
	$('.wide-carousel .image-carousel-boxes').slick({
	  slidesToShow: 1,
	  slidesToScroll: 1,
	  asNavFor: '.wide-carousel .text-carousel-boxes',
	  dots: false,
	  centerMode: false,
	  focusOnSelect: true,
	  nextArrow:  $('.wide-carousel .carousel-navigation .arrows .next'),
	  prevArrow:  $('.wide-carousel .carousel-navigation .arrows .prev'),
	});
	
	$('.image-only-carousel-boxes').slick({
	  slidesToShow: 1,
	  slidesToScroll: 1,
	  dots: false,
	  centerMode: false,
	  focusOnSelect: true,
	  nextArrow:  $('.carousel-navigation .arrows .next'),
	  prevArrow:  $('.carousel-navigation .arrows .prev'),

	});
	$('.menu-carousel-boxes').slick({
	  slidesToShow: 2,
	  slidesToScroll: 1,
	  dots: false,
	  centerMode: false,
	  focusOnSelect: true,
	  infinite: false,
	  nextArrow:  $('.carousel-navigation .arrows .next'),
	  prevArrow:  $('.carousel-navigation .arrows .prev'),
	  responsive: [
	    {
	      breakpoint: 1024,
	      settings: {
	        slidesToShow: 1,
	      }
	    },
	  ]
	});
	
	$('.tripadvisor-carousel-boxes').slick({
	  slidesToShow: 1,
	  slidesToScroll: 1,
	  dots: false,
	  centerMode: false,
	  focusOnSelect: true,
	  infinite: true,
	  nextArrow:  $('.tripadvisor-carousel-wrapper .carousel-navigation .arrows .next'),
	  prevArrow:  $('.tripadvisor-carousel-wrapper .carousel-navigation .arrows .prev'),
	  //adaptiveHeight: true
	});
	
	$('.video-banner').backstretch([
		{url: $('.video-banner').data('background'), isVideo: true, loop: true, mute:true}
	]);
	
	if(jQuery('.submit-success').length) {
		$('.footer .social.clone').clone().appendTo(".submit-success");
	}
	
	if(jQuery('#slide01').length) {
		
		function initialFade() {
			jQuery('.fullscreen').addClass('loaded');
			if(jQuery(window).width() > 1200) {
				TweenMax.fromTo(".scene1", .2, {y: 0, scale: 1.0}, {y: 0, scale: 1, delay: .7} );
				TweenMax.fromTo(".scene2", .2, {y: 25, x: 235, scale: 1.05}, {y: 0, x: 350, scale: 1, delay: .7} );
				TweenMax.fromTo(".scene3", .2, {y: 50,x: -235, scale: 1.1}, {y: 0, x: -350, scale: 1, delay: .7} );
				TweenMax.fromTo(".scene4", .2, {y: 75, scale: 1.15}, {y: 0, scale: 1, delay: .7});
			 } else if(jQuery(window).width() > 768 && jQuery(window).width() < 1200){
			 	TweenMax.fromTo(".scene1", .2, {y: 0, scale: 1.0}, {y: 0, scale: 1, delay: .7} );
				TweenMax.fromTo(".scene2", .2, {y: 25, scale: 1.05}, {y: 0, x: 0, scale: 1, delay: .7} );
				TweenMax.fromTo(".scene3", .2, {y: 50, scale: 1.1}, {y: 0, x: 0, scale: 1, delay: .7} );
				TweenMax.fromTo(".scene4", .2, {y: 75, scale: 1.15}, {y: 0, scale: 1, delay: .7});
			 } else {
			 	TweenMax.fromTo($('#slide02 .step1'), 0.7, {y: '+=20', autoAlpha: 0}, {y: 0, autoAlpha: 1, ease:Power1.easeOut}, '+=0.2');
			    TweenMax.fromTo($('#slide02 .step2'), 0.7, {y: '+=20', autoAlpha: 0}, {y: 0, autoAlpha: 1, ease:Power1.easeOut}, '+=0.2');
			    TweenMax.fromTo($('#slide02 .step3'), 0.7, {y: '+=20', autoAlpha: 0}, {y: 0, autoAlpha: 1, ease:Power1.easeOut}, '+=0.2');
			 }
				TweenMax.fromTo("#slide01 .cell", .5, {y: '+=20', autoAlpha: 0}, {y: 0, autoAlpha: 1, ease:Power1.easeOut, delay: 1.5});
				TweenMax.fromTo("#slide01 .weather-embed", .5, {y: '+=20', autoAlpha: 0}, {y: 0, autoAlpha: 1, ease:Power1.easeOut, delay: 2});
			
		}
		$('#slide01').imagesLoaded( function() {
			initialFade();
			var pinScene01Tl = new TimelineMax();
			var ctrl = new ScrollMagic.Controller({
			    globalSceneOptions: {
			        triggerHook: 'onLeave'
			    }
			});
			var horizontal = 0;
			
			if(jQuery(window).width() > 1200) {
				horizontal = 235;
			}
			pinScene01Tl
			    .to(".scene1", 1, {y: 0, scale: 1.05})
			    .to(".scene2", 1, {y: 70, x: horizontal, scale: 1.1}, '-=1')
			    .to(".scene3", 1, {y: 130,x: -horizontal, scale: 1.2}, '-=1')
			    .to(".scene4", 1, {y: 150, scale: 1.3}, '-=1');
			 
			var pinScene01 = new ScrollMagic.Scene({
			    triggerElement: '#slide01',
			    triggerHook: 0,
			    duration: "130%"
			})
			.setPin("#slide01")
			.setTween(pinScene01Tl)
			.addTo(ctrl);
			
			function callback (event) {
			    jQuery('header.header').toggleClass('standard');
			}
			// add listeners
			pinScene01.on("end", callback);
			
			var pinScene02Tl = new TimelineMax();
	 
			pinScene02Tl
			    .fromTo($('#slide02 .step1'), 0.7, {y: '+=20', autoAlpha: 0}, {y: 0, autoAlpha: 1, ease:Power1.easeOut}, '+=0.2')
			    .fromTo($('#slide02 .step2'), 0.7, {y: '+=20', autoAlpha: 0}, {y: 0, autoAlpha: 1, ease:Power1.easeOut}, '+=0.2')
			    .fromTo($('#slide02 .step3'), 0.7, {y: '+=20', autoAlpha: 0}, {y: 0, autoAlpha: 1, ease:Power1.easeOut}, '+=0.2');
			 
			var pinScene02 = new ScrollMagic.Scene({
			    triggerElement: '#slide02',
			    triggerHook: 0,
			    duration: "130%"
			})
			.setPin("#slide02")
			.setTween(pinScene02Tl)
			.addTo(ctrl);
			
			if(jQuery(window).width() < 768) {
				ctrl = ctrl.destroy(true);
			}
			
		});
		
		}
	
	jQuery('.overlap-image').hover(
       function(){ jQuery(this).addClass('hover'); jQuery(this).siblings('.overlap-image').addClass('hover-off'); },
       function(){ jQuery(this).removeClass('hover'); jQuery(this).siblings('.overlap-image').removeClass('hover-off'); }
	);
	
	new Foundation.Equalizer(jQuery('#equal'));	
	
	if(jQuery('.form-group.tickets').length) {
		
		jQuery('<div class="quantity-nav"><div class="quantity-button quantity-up">+</div><div class="quantity-button quantity-down">-</div></div>').insertAfter('.tickets input[type=number]');
		    jQuery('.tickets > div').each(function() {
		      var spinner = jQuery(this),
		        input = spinner.find('input[type="number"]'),
		        btnUp = spinner.find('.quantity-up'),
		        btnDown = spinner.find('.quantity-down'),
		        min = input.attr('min'),
		        max = input.attr('max');
		
		      btnUp.click(function() {
		        var oldValue = parseFloat(input.val());
		        if (oldValue >= max) {
		          var newVal = oldValue;
		        } else {
		          var newVal = oldValue + 1;
		        }
		        spinner.find("input").val(newVal);
		        spinner.find("input").trigger("change");
		      });
		
		      btnDown.click(function() {
		        var oldValue = parseFloat(input.val());
		        if (oldValue <= min) {
		          var newVal = oldValue;
		        } else {
		          var newVal = oldValue - 1;
		        }
		        spinner.find("input").val(newVal);
		        spinner.find("input").trigger("change");
		      });
		
		    });
		
	}
	
	jQuery('.date-picker input[type=text]').datepicker({
		dateFormat: "dd-mm-yy",
		minDate: 0,
		beforeShowDay: noWeekendsOrHolidays
	});
	
	jQuery('.date-picker input[type=text]').attr('readonly', true);
	
	
	$("#booking-conditions").change(function() {
		if(this.checked) {
			jQuery('.booking-button').attr('disabled', false);//Do stuff
		} else {
			jQuery('.booking-button').attr('disabled', true);//
		}
	});
	jQuery('.booking-button').on('click', function(e) {

		if(jQuery(this).attr('disabled')) {
	
			e.preventDefault();
		}
	});
});

function noWeekendsOrHolidays(date) {
    var noWeekend = jQuery.datepicker.noWeekends(date);
    if (noWeekend[0]) {
	    if (!Array.isArray(date_array) || !date_array.length) {
			return [true];
		} else {
			return nationalDays(date);
		}
        
    } else {
        return noWeekend;
    }
   
}


function nationalDays(date) {

		for (i = 0; i < date_array.length; i++) {
	      var string = jQuery.datepicker.formatDate('dd-mm-yy', date);
	        return [ date_array.indexOf(string) == -1 ]
	    }
	
    

}



var initialOptions = [];

jQuery('.time-picker select option').each(function() {
	initialOptions.push(jQuery(this).val());
});

jQuery('.date-picker input').change(function() { 
	

	var date = jQuery(this).val();
	jQuery(".time-picker select").val('');
	jQuery(".time-picker select").find('option').remove();
	
	jQuery.each( initialOptions, function( key, value ) {
		jQuery('<option>').val(value).text(value).appendTo('.time-picker select');
	});

	if( date in date_times ) {
		
		jQuery.each( date_times[date], function( key, value ) {
		    
			jQuery(".time-picker select option[value='" + value + "']").remove();
		});
		
	} 


	

});

  
function reveal_form_success( obj ) {
	
    if ( "complete" == obj.status ) {
        
        jQuery('#breadcrumb_1_pg_3').click();
        
    }
    
}

// request tour states
jQuery( document ).on( 'cf.pagenav', function(  ){
	var breadcrumb = jQuery('ol.breadcrumb');
	var active_link = breadcrumb.find('li.active a');
	var page = active_link.data('page');
	
	breadcrumb.attr("data-active-page",page);
	
});


function debounce(func, wait, immediate) {
	var timeout;
	return function() {
		var context = this, args = arguments;
		var later = function() {
			timeout = null;
			if (!immediate) func.apply(context, args);
		};
		var callNow = immediate && !timeout;
		clearTimeout(timeout);
		timeout = setTimeout(later, wait);
		if (callNow) func.apply(context, args);
	};
};


var lethargy = new Lethargy(); // Use defaults


// header scroll state
// Initial state
var scrollPos = 0;
var headerScroll = function() {
	  // detects new state and compares it with the new one
	
	if(scrollPos > -20) {
		jQuery('header.header').addClass('top');
		document.getElementById('header').setAttribute('data-scroll-direction', 'top');
		
	} else {
		if ((document.body.getBoundingClientRect()).top > scrollPos) {
			document.getElementById('header').setAttribute('data-scroll-direction', 'up');
		} else {
			document.getElementById('header').setAttribute('data-scroll-direction', 'down');
		}
		jQuery('header.header').removeClass('top');	
	}
  	
	// saves the new position for iteration.
	scrollPos = (document.body.getBoundingClientRect()).top;
	
	
};
// adding scroll event
window.addEventListener('scroll',headerScroll);
  






// cookie banner
function getCookie(cname) {
  var name = cname + "=";
  var ca = document.cookie.split(';');
  for (var i = 0; i < ca.length; i++) {
    var c = ca[i];
    while (c.charAt(0) == ' ') c = c.substring(1);
    if (c.indexOf(name) == 0) return c.substring(name.length, c.length);
  }
  return "";
}
function createAcceptCookie() {
  var cookieBanner = document.getElementById("cookie-banner");
  document.cookie = "accepted_cookie_policy=yes; expires=" + setExpiryDate() + ";";
  cookieBanner.classList.add("accepted");
  cookieBanner.classList.add("display");
}
function setExpiryDate() {
  var d = new Date();
  d.setFullYear(d.getFullYear() + 1);
  return d.toUTCString();
}

function createClosingAcceptCookie() {
  var cookieClosingBanner = document.getElementById("closing-banner");
  sessionStorage.setItem('acceptClosed', 'yes');
  cookieClosingBanner.classList.add("accepted");
  cookieClosingBanner.classList.add("display");
}
function setClosingExpiryDate() {
  	var d = new Date();
	d.setDate(d.getDate()+1); 
	return d.toUTCString();
}


function display_popup_onload() {
	
	if(jQuery('#closing-banner').length) {
		$popup = jQuery('#closing-banner');

		var isClosingCookieSet = sessionStorage.getItem('acceptClosed');
		if (isClosingCookieSet !== "yes") {
			var start_time = $popup.data('start');
			var stop_time = $popup.data('stop');

			if (isBetweenDates(start_time, stop_time)) {
				// display popup
				$popup.foundation('open');

			}
		} 
	}
}
jQuery(document).on('closed.zf.reveal', '#closing-banner', function () {
	sessionStorage.setItem('acceptClosed', 'yes');
});


function isBetweenDates(startDate, endDate) {
	const currentDate = new Date().toISOString().replace(/T/, ' ').replace(/\..+/, '');
	let startDateUTC = null;
	let endDateUTC = null;

	if (startDate) {
		startDateUTC = startDate;
	}

	if (endDate) {
		endDateUTC = endDate;
	}

	const currentDateUTC = new Date().toISOString().replace(/T/, ' ').replace(/\..+/, '');

	if (startDateUTC && endDateUTC) {
		return (currentDateUTC >= startDateUTC && currentDateUTC <= endDateUTC);
	} else if (startDateUTC) {
		return (currentDateUTC >= startDateUTC);
	} else if (endDateUTC) {
		return (currentDateUTC <= endDateUTC);
	} else {
		return true;
	}
}

if (!String.prototype.includes) {
    String.prototype.includes = function(search, start) {
      if (typeof start !== 'number') {
        start = 0;
      }

      if (start + search.length > this.length) {
        return false;
      } else {
        return this.indexOf(search, start) !== -1;
      }
    };
  }
if (!Element.prototype.matches) {
  Element.prototype.matches = Element.prototype.msMatchesSelector || 
                              Element.prototype.webkitMatchesSelector;
}

if (!Element.prototype.closest) {
  Element.prototype.closest = function(s) {
    var el = this;

    do {
      if (el.matches(s)) return el;
      el = el.parentElement || el.parentNode;
    } while (el !== null && el.nodeType === 1);
    return null;
  };
}


if(jQuery('#timeline').length) {
	

	//document.body.addEventListener('wheel', doMagic);
	
	//document.getElementById("timeline").addEventListener('wheel', doMagic);
	var lethargyWait = false;
	var lethargyTimeout = 500;
	jQuery('#timeline').bind('mousewheel DOMMouseScroll wheel MozMousePixelScroll', function(e){
	    e.preventDefault()
	    e.stopPropagation();
	    
	    var direction = lethargy.check(e);
	    
	   
	    if(direction !== false && lethargyWait != true) {
		  
	       doMagic(e, direction);
	       lethargyWait = true;
			setTimeout(function() {
				lethargyWait = false; 
			}, lethargyTimeout);
		}
	});
	
	var ts;
	jQuery('#timeline-anchor').bind('touchstart', function (e){
		e.preventDefault();
	   ts = e.originalEvent.touches[0].clientY;
	});
	
	jQuery('#timeline-anchor').bind('touchend', function (e){
		e.preventDefault();
	   var te = e.originalEvent.changedTouches[0].clientY;
	   //console.log(e.originalEvent.changedTouches);
	   var tags = ['SECTION'];
	   //console.log(e);
	   if (e.target.nodeName.toString() === 'SECTION') {
	    // Element is one of our top level structure tags.
	    // Get its adjacent siblings.
	    var next = e.target.nextElementSibling,
	        prev = e.target.previousElementSibling;
	        
	        //console.log(next);
	        //console.log(prev);

	  } else if(e.target.closest(tags)) { // If it's rather a child go up the DOM tree
	           // until we meet one of our top level tags
	           // and get the siblings from there.
	           // .closest() is quite well supported but far from 100%
	           // http://stackoverflow.com/a/42873108 provides a solution
	           // for a compatibility fix
	    var next = e.target.closest(tags).nextElementSibling,
	        prev = e.target.closest(tags).previousElementSibling;
	        //console.log(next);
	        //console.log(prev);
	
	  } 

	   if(ts > te+5){
		   
	      if(next) {
		      /*scrollIt(
		        // The scrollIt function was written by Pawel Grzybek.
		        // It's a very neatly written vanilla smooth scroll.
		        // Find his awesome code in the JS options tab of this pen.
		        next, // Use the stored .previousElementSibling as target.
		        400, // Animation duration
		        'easeInOutQuad' // Easing (see Pawels pen)
		      );*/
		      next.scrollIntoView({ behavior: 'smooth' });
		      e.target.closest(tags).classList.remove('show');
			  next.classList.add('show');
			  jQuery('.history-nav a').removeClass('is-active');
			  jQuery('.history-nav a[data-section="'+next.id+'"]').addClass('is-active');
	      } else {
		    
	        document.getElementById('video').scrollIntoView({ behavior: 'smooth' });
	        
	    }
	      
	   }else if(ts < te-5){
	     if(prev) {
		      prev.scrollIntoView({ behavior: 'smooth' });
		      e.target.closest(tags).classList.remove('show');
			  prev.classList.add('show');
			  jQuery('.history-nav a').removeClass('is-active');
			  jQuery('.history-nav a[data-section="'+prev.id+'"]').addClass('is-active');
	     } else {
		   
	        document.getElementById('main').scrollIntoView(true, { behavior: 'smooth' });
	   
	    } 
	      
	   }
	});
	
	var waypoint = new Waypoint({
	  element: document.getElementById('timeline'),
	  handler: function(direction) {
	    if(direction == 'down') {
			document.getElementById('1930').scrollIntoView({ behavior: 'smooth' });
			
	    }
	  },
	  offset: '70%'
	});

}

jQuery(".history-nav a").on("click",function(e){
	var $id = jQuery(this).data('section');
	jQuery('.history-nav a').removeClass('is-active');
	jQuery(this).addClass('is-active');
	
    document.getElementById($id).scrollIntoView({ behavior: 'smooth' });
        
	
});

// The following function is based on my structural ideas of a One Page Website and if you get the idea it's really trivial to adjust it to yours.
function doMagic(e, direction) {
  //console.log(e);
  // Store your top level full page element tags in a variable.
  // This is to have control over your structure and
  // to avoid <script> tags from being included in the process.
  // These need to be uppercase as .nodeName returns that way
  var tags = ['SECTION'];
  
  var takeover = false;
  // Test for the DOM element the wheel event was fired on
  // and store the next page section for later use.
  if (e.target.nodeName.toString() === 'SECTION') {
    // Element is one of our top level structure tags.
    // Get its adjacent siblings.
    var next = e.target.nextElementSibling,
        prev = e.target.previousElementSibling;
    takeover = true;
  } else if(e.target.closest(tags)) { // If it's rather a child go up the DOM tree
           // until we meet one of our top level tags
           // and get the siblings from there.
           // .closest() is quite well supported but far from 100%
           // http://stackoverflow.com/a/42873108 provides a solution
           // for a compatibility fix
    var next = e.target.closest(tags).nextElementSibling,
        prev = e.target.closest(tags).previousElementSibling;
    takeover = true;
  } else {
	takeover = false;  
	return false;
  }
  
  if(takeover) {
	  
  
	  if (direction == 1) { // Wheel scrolled up
	    // Block native scroll:
	  
	    // Make sure that the sibling element is one
	    // of our top structure tags.
	    // May not be necessary but I've had weird behaviours
	    // with <script> tags and you might want to exclude things.
	    
	    if (prev && prev.nodeName.toString() === 'SECTION') {
	      // Use a nice smooth scroll:
	      
	      
	      prev.scrollIntoView({ behavior: 'smooth' })
	      // Toggle class for nice transitions
	      e.target.closest(tags).classList.remove('show');
	      prev.classList.add('show');
	     
	      jQuery('.history-nav a').removeClass('is-active');
	      jQuery('.history-nav a[data-section="'+prev.id+'"]').addClass('is-active');
	    } else {
		    document.getElementById('main').scrollIntoView({ behavior: 'smooth' });
		    
	    }
	  } else if (direction == -1) { // Wheel scrolled down
	    // Just the same as before but with the following adjacent sibling.
	
	    if (next && next.nodeName.toString() === 'SECTION') {
	      next.scrollIntoView({ behavior: 'smooth' });
	      e.target.closest(tags).classList.remove('show');
	      next.classList.add('show');
	      jQuery('.history-nav a').removeClass('is-active');
	      jQuery('.history-nav a[data-section="'+next.id+'"]').addClass('is-active');
	    } else {
		    document.getElementById('video').scrollIntoView({ behavior: 'smooth' });
	    }
	  } else {
	    return false;
	  }
  }
}
function scrollIt(destination, duration = 200, easing = 'linear', callback) {

  // Predefine list of available timing functions
  // If you need more, tween js is full of great examples
  // https://github.com/tweenjs/tween.js/blob/master/src/Tween.js#L421-L737
  const easings = {
    linear(t) {
      return t;
    },
    easeInQuad(t) {
      return t * t;
    },
    easeOutQuad(t) {
      return t * (2 - t);
    },
    easeInOutQuad(t) {
      return t < 0.5 ? 2 * t * t : -1 + (4 - 2 * t) * t;
    },
    easeInCubic(t) {
      return t * t * t;
    },
    easeOutCubic(t) {
      return (--t) * t * t + 1;
    },
    easeInOutCubic(t) {
      return t < 0.5 ? 4 * t * t * t : (t - 1) * (2 * t - 2) * (2 * t - 2) + 1;
    },
    easeInQuart(t) {
      return t * t * t * t;
    },
    easeOutQuart(t) {
      return 1 - (--t) * t * t * t;
    },
    easeInOutQuart(t) {
      return t < 0.5 ? 8 * t * t * t * t : 1 - 8 * (--t) * t * t * t;
    },
    easeInQuint(t) {
      return t * t * t * t * t;
    },
    easeOutQuint(t) {
      return 1 + (--t) * t * t * t * t;
    },
    easeInOutQuint(t) {
      return t < 0.5 ? 16 * t * t * t * t * t : 1 + 16 * (--t) * t * t * t * t;
    }
  };


  // Store initial position of a window and time
  // If performance is not available in your browser
  // It will fallback to new Date().getTime() - thanks IE < 10
  const start = window.pageYOffset;
  const startTime = 'now' in window.performance ? performance.now() : new Date().getTime();
  // const startTime = typeof(window.performance['now']) == 'function' ? performance.now() : new Date().getTime();


  // Take height of window and document to sesolve max scrollable value
  // Prevent requestAnimationFrame() from scrolling below maximum scollable value
  // Resolve destination type (node or number)
  const documentHeight = Math.max(document.body.scrollHeight, document.body.offsetHeight, document.documentElement.clientHeight, document.documentElement.scrollHeight, document.documentElement.offsetHeight);
  const windowHeight = window.innerHeight || document.documentElement.clientHeight || document.getElementsByTagName('body')[0].clientHeight;
  const destinationOffset = typeof destination === 'number' ? destination : destination.offsetTop;
  const destinationOffsetToScroll = Math.round(documentHeight - destinationOffset < windowHeight ? documentHeight - windowHeight : destinationOffset);


  // If requestAnimationFrame is not supported
  // Move window to destination position and trigger callback function
  if ('requestAnimationFrame' in window === false) {
	  
    window.scroll(0, destinationOffsetToScroll);
    if (callback) {
      callback();
    }
    return;
  }


  // function resolves position of a window and moves to exact amount of pixels
  // Resolved by calculating delta and timing function choosen by user
  function scroll() {
    const now = 'now' in window.performance ? performance.now() : new Date().getTime();
    const time = Math.min(1, ((now - startTime) / duration));
    const timeFunction = easings[easing](time);
    window.scroll(0, Math.ceil((timeFunction * (destinationOffsetToScroll - start)) + start));

    // Stop requesting animation when window reached its destination
    // And run a callback function
    if (window.pageYOffset === destinationOffsetToScroll) {
      if (callback) {
        callback();
      }
      return;
    }

    // If window still needs to scroll to reach destination
    // Request another scroll invokation
    requestAnimationFrame(scroll);
  }


  // Invoke scroll and sequential requestAnimationFrame
  scroll();
}


/*
// overlap on timeline
var is_colliding = function( $div1, $div2 ) {
	// Div 1 data
	var d1_offset             = $div1.offset();
	var d1_height             = $div1.outerHeight( true );
	var d1_width              = $div1.outerWidth( true );
	var d1_distance_from_top  = d1_offset.top + d1_height;
	var d1_distance_from_left = d1_offset.left + d1_width;

	// Div 2 data
	var d2_offset             = $div2.offset();
	var d2_height             = $div2.outerHeight( true );
	var d2_width              = $div2.outerWidth( true );
	var d2_distance_from_top  = d2_offset.top + d2_height;
	var d2_distance_from_left = d2_offset.left + d2_width;

	var not_colliding = ( d1_distance_from_top < d2_offset.top || d1_offset.top > d2_distance_from_top || d1_distance_from_left < d2_offset.left || d1_offset.left > d2_distance_from_left );

	// Return whether it IS colliding
	return ! not_colliding;
};

function debounce(func, wait, immediate) {
	var timeout;
	return function() {
		var context = this, args = arguments;
		var later = function() {
			timeout = null;
			if (!immediate) func.apply(context, args);
		};
		var callNow = immediate && !timeout;
		clearTimeout(timeout);
		timeout = setTimeout(later, wait);
		if (callNow) func.apply(context, args);
	};
};

var resizeScroll = debounce(function() {
	findOverlaps();
}, 250);


var collides = false;
var fields = jQuery('.change-color');
function findOverlaps() {
	if(jQuery('.history-nav').length) {
				
		
		for (var fieldIndex = 0; fieldIndex < fields.length; fieldIndex ++) {
			
			if(is_colliding(jQuery('.history-nav'), jQuery(fields[fieldIndex]))){
				collides = true;
			
			
				break;
				
			} else {
				collides = false;
				
				
			}
		}

		if(collides === true) {
			jQuery('.history-nav').addClass('off');
		} else {
			jQuery('.history-nav').removeClass('off');
		}
	
		
	}
}
*/